import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import withStyles from '@material-ui/styles/withStyles';
import { Grid, Drawer, CircularProgress, Typography } from '@material-ui/core';

import { getIntegrityManagementWellRiskScoresTrendState } from 'features/settings/integrityManagement/helpers/integrityManagement.selectors';
import { loadIntegrityManagementRiskTrendScoresForWell } from 'features/settings/integrityManagement/helpers/integrityManagement.actions';
import RiskMatrixHistoryDrawerContent from 'features/wells/integrity/history/RiskMatrixHistoryDrawerContent';
import RiskMatrixHistoryDrawerHeader from 'features/wells/integrity/history/RiskMatrixHistoryDrawerHeader';

const RiskMatrixHistoryDrawer = ({
  isOpen,
  toggleDrawer,
  classes,
  dispatchLoadIntegrityRiskScoreTrendForWell,
  riskTrendScores,
  externalWellboreId,
}) => {
  useEffect(() => {
    if (externalWellboreId) {
      dispatchLoadIntegrityRiskScoreTrendForWell(externalWellboreId);
    }
  }, [dispatchLoadIntegrityRiskScoreTrendForWell, externalWellboreId]);

  useEffect(() => {
    if (riskTrendScores && riskTrendScores.size > 0) {
    }
  }, [riskTrendScores]);

  return (
    <>
      <Drawer
        anchor="right"
        open={isOpen}
        onClose={toggleDrawer}
        classes={{
          paper: classes.drawerPaper,
        }}
      >
        <Grid className={classes.drawerHeader}>
          <RiskMatrixHistoryDrawerHeader toggleDrawer={toggleDrawer} />
        </Grid>
        {riskTrendScores ? (
          riskTrendScores.size > 0 ? (
            <Grid className={classes.drawerContent}>
              <RiskMatrixHistoryDrawerContent
                toggleDrawer={toggleDrawer}
                riskTrendScores={riskTrendScores}
              />
            </Grid>
          ) : (
            <Grid>
              <Typography variant="body1" noWrap>
                History Not Available
              </Typography>
            </Grid>
          )
        ) : (
          <Grid className={classes.circularProgress}>
            <CircularProgress size={40} />
          </Grid>
        )}
      </Drawer>
    </>
  );
};

const styles = (theme) => ({
  drawerPaper: {
    width: '30%',
    minWidth: 300,
    background: theme.palette.background.default,
  },
  drawerHeader: {
    position: 'sticky',
    top: 0,
    zIndex: 1000,
    background: theme.palette.background.default,
    padding: theme.spacing(2),
    marginBottom: theme.spacing(2),
    borderBottom: `2px solid ${theme.palette.table.row.hover}`,
  },
  drawerContent: {
    overflowY: 'scroll-y',
  },
  circularProgress: {
    display: 'flex',
    justifyContent: 'center',
  },
});

export default compose(
  connect(
    (state, { externalWellboreId }) => {
      if (!externalWellboreId) {
        return { riskTrendScores: null };
      }
      return {
        riskTrendScores: getIntegrityManagementWellRiskScoresTrendState(
          state,
          externalWellboreId,
        ),
      };
    },
    {
      dispatchLoadIntegrityRiskScoreTrendForWell:
        loadIntegrityManagementRiskTrendScoresForWell,
    },
  ),
  withStyles(styles),
)(RiskMatrixHistoryDrawer);
